/*
Author: Vaishnavi
Date: 21/11/2019
Issue Description: Upload logo/image file as per design guidelines
*/
/*
Author: Siddharth
Date: 03/12/2019
Issue Description: Crop and Zoom Image functionality
*/
/*
Author: Vinod
Date: 13/03/2020
Issue No.:PL-2911
Issue Description: Uploaded logo is not displaying.
search_string:PL_2911
*/
<template>
  <!-- Usage
  <upload-image name="annex" tobucket="false" @change="onFileChange($event,'annexure')" :status="statusAnnex" :logo=formData.logo></upload-image>-->
  <!-- if there is no logo -->
  <div>
    <!-- if there is no logo -->
    <div
      class="upload-img"
      v-if="status && !logo"
      @dragover.prevent
      @drop="upload_file"
      @dragover="dragging"
      :class="{'dragg': dragg}"
    >
      <img src="@/assets/companyLogo.svg" />
      <div class="textalign">
        <div class="upload-btn-text">Click button below to browse file from your computer.</div>
        <div class="upload-button">
          <label :for="name" class="upload-btn">{{uploadBtnText}}</label>
          <!-- <button >Upload Logo</button><br/>  -->
          <input
            type="file"
            name="photo"
            class="upload-photo"
            :id="name"
            @change="uploadFile($event.target.files[0])"
          />
        </div>
        <div class="upload-btn-below-text">JPG, JPEG or PNG. Max size 100KB</div>
      </div>
    </div>
    <div class="uploading" v-show="uploading">
      <!-- <div class="uploading-container">
        <div class="upload-info">
          <div class="uploading-btn-text">Uploading</div>
          <div class="uploading-btn-text">{{ file.name }}</div>
          <div class="progress-bar">
            <div class="progress complete">
            </div>
          </div>
          <div class="uploading-btn-text size">{{ parseInt(file.size / 1024) }}kb</div>
        </div>
        <button class="btn-secondary" @click="status=true
          uploading=false">Cancel</button>
      </div>-->
      <div class="uploadingstate">
        <img src="@/assets/companyLogo.svg" />
        <div id="animated" />
      </div>

      <div class="textalign">
        <div class="upload-btn-text">File is being uploaded. Please wait.</div>
        <div class="upload-button">
          <button
            class="btn-secondary retry-btn"
            @click="(status,uploading) => {status = true, uploading = false}"
          >Cancel</button>
          <!-- @click="(status,uploading) => status = true, uploading = false" -->
          <!-- <label :for="name" class="retry-btn">Cancel</label>
            <input
                type="file"
                name="photo"
                class="upload-photo"
                :id="name"
                @change="uploadFile($event.target.files[0])"
          />-->
        </div>
        <div class="upload-btn-below-text">JPG, JPEG or PNG. Max size of 100KB, Min size of 50KB</div>
      </div>
    </div>
    <div class="uploaded" v-if="logo">
      <div class="image-wrapper">
        <img :src="logo" class="legal-entity-logo" />
        <!-- Author: Vaishnavi
                  Date: 21/11/2019
        Issue: Edit image added for a company logo and css is in custom.scss (line no. 57-60)-->
        <div class="delete-img">
          <img class="edit-icon" @click="editImage(logo)" src="@/assets/editLogo.svg" />
          <img class="delete-icon" @click="del()" src="@/assets/deleteLogo.svg" />
        </div>
        <div class="textalign">
          <div class="upload-btn-text">This logo will appear on Payslips and other documents.</div>
          <div class="upload-button">
            <label for="upload" class="upload-btn">Upload New</label>
            <input
              type="file"
              name="photo"
              class="upload-photo"
              id="upload"
              @change="uploadFile($event.target.files[0])"
            />
          </div>
          <div class="upload-btn-below-text">JPG, JPEG or PNG. Max size of 100KB, Min size of 50KB</div>
          <p class="uploadText" v-if="showUploadText">Uploaded successfully</p>
        </div>
      </div>
    </div>
    <div class="upload-failed" v-if="failed">
      <!-- <div class="upload-container">
        <div class="row-container">
          <img src="@/assets/warning_error.svg" class="errorimage" />
          <div class="upload-btn-text">File Upload Failed</div>
        </div>
        <br />
        <div class="row-container">

          <div class="upload-file-text">{{ file.name}}</div>
          <div class="upload-button">
            <label :for="name">Retry</label>
            <input type="file" name="photo" :id="name" class="upload-photo" @change="retry($event)" />
          </div>
        </div>

      </div>-->
      <div class="imgAlign">
        <img src="@/assets/warning_error.svg" />
      </div>
      <div class="textalign">
        <div class="upload-btn-text">File Upload Failed</div>
        <div class="upload-button">
          <label for="upload" class="retry-btn">Retry</label>
          <!-- <button >Upload Logo</button><br/>  -->
          <input
            type="file"
            name="photo"
            class="upload-photo"
            id="upload"
            @change="uploadFile($event.target.files[0])"
          />
        </div>
        <div class="upload-btn-below-text">JPG, JPEG or PNG. Max size of 100K, Min size of 50KBB</div>
      </div>
    </div>
    <!-- Author: Siddharth
      Date: 03/12/2019
    Issue: Crop and Zoom Image functionality-->
    <!-- Start Crop and zoom image - 03/12/2019 -->
    <pop-up-message
      v-if="showPopup"
      :message="popupMessage"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Delete'"
      :closable="false"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancelEvent()">Cancel</button>
          <button class="btn-popup" type="button" @click="deleteEvent()">Delete</button>
        </div>
      </template>
    </pop-up-message>
    <div class="modal custom-modal" v-if="showCropOption">
      <div class="modal-content modal-sm payslip-modal">
        <div class="modal-header">
          <h3>Crop Image</h3>
        </div>
        <div class="modal-body content-center">
          <div class="cropImage">
            <vue-cropper
              ref="cropper"
              :src="logo"
              :viewMode="1"
              :movable="true"
              preview=".preview"
            />
            <div class="cropImgActionButtons">
              <div class="btnOpt">
                <a href="javascript:void(0)" @click="rotate(-90)" class="addNewOrg">
                  <i class="material-icons rotateIconImage">rotate_left</i>
                </a>
                <a href="javascript:void(0)" @click="rotate(90)" class="addNewOrg">
                  <i class="material-icons rotateIconImage rightIcon">rotate_right</i>
                </a>
              </div>
              <span class="rightBtns">
                <button class="cancelImage" @click.prevent="zoom(0.2)">Zoom In</button>
                <button class="cancelImage" @click.prevent="zoom(-0.2)">Zoom Out</button>
              </span>
              <div class="upload-button setAlignment">
                <label for="upload" class="retry-btn replaceImageBtn">Replace Image</label>
                <input
                  type="file"
                  name="replaceFile"
                  class="upload-photo"
                  id="replaceFile"
                  @change="uploadFile($event.target.files[0])"
                />
                <span class="rightBtns">
                  <button class="cancelImage" @click="close()">Cancel</button>
                  <button @click="cropImage()" class="setImage">Set Image</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Crop and zoom image - 03/12/2019 -->
  </div>
</template>

<script>
import {
  get_axios_file_instance,
  api_variables,
  errorHandler
} from "@/apis/variables.js";
import { mapGetters, mapActions, mapState } from "vuex";
var axios_instance = get_axios_file_instance(api_variables.SERVICE_UPLOAD_LOGO);
export default {
  props: {
    maxSize: {
      type: Number,
      default: 102400 //5242880 pl-3928
    }, 
    // pl-3928
    minSize: {
      type: Number,
      default: 51200
    },
    name: {
      type: String,
      default: "upload"
    },
    tobucket: {
      type: Boolean,
      default: true
    },
    logo: {
      type: String
    },
    uploadBtnText: {
      type: String,
      default: "Upload Logo"
    },
    includeLeId: {
      type: Boolean,
      default: false // Indicates whether to include le_id in formData
    }
    // status:{
    //   type: Number,
    //    default: 0
    // }
  },
  data() {
    return {
      // status 0 for notUploaded
      // status 1 for uploading
      // status 2 for uploaded
      file: null,
      cropped: null,
      count: 1,
      popupType: "Warning",
      popupMessage: "Are you sure you want to delete ?",
      showPopup: false,
      showUploadText: false,
      status: true,
      showCropOption: false,
      uploading: false,
      uploaded: false,
      failed: false,
      uploadedUrl: "",
      dragg: false,
      pdfPattern: "([a-zA-Z0-9s_\\.-:])+(.pdf)$",
      xlsPattern: "([a-zA-Z0-9s_\\.-:])+(.xls|.xlsx)$",
      imgPattern: "([a-zA-Z0-9s_\\.-:])+(.png|.jpg|.jpeg)$"
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  activated() {
    this.status = true;
    if (this.logo) {
      this.uploaded = true;
      this.uploading = false;
      this.failed = false;
    } else {
      this.uploaded = false;
      this.uploading = false;
      this.failed = false;
    }
  },
  methods: {
    fileType() {
      if (this.file.type == "xls") {
        return require("@/assets/excel.svg");
      } else {
        if (this.file.type == "pdf") {
          return require("@/assets/pdf.svg");
        } else {
          return require("@/assets/image.svg");
        }
      }
    },
    retry(event) {
      this.failed = false;
      this.uploadFile(event.target.files[0]);
    },
    upload_file(e) {
      e.stopPropagation();
      e.preventDefault();
      this.uploadFile(e.dataTransfer.files[0]);
    },
    dragging(e) {
      this.dragg = true;
    },
    async uploadFile(uploadFile) {
      try {
        this.count += 1;
        this.dragg = false;
        if ( uploadFile && uploadFile.type == // PL_2911
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          this.$emit("uploadTemplate", uploadFile);
          return;
        }

        if (uploadFile && uploadFile.name) {  // PL_2911
          if (this.logo) {
            this.uploaded = true;
            this.uploading = false;
          }
          if (uploadFile.size > parseInt(this.maxSize)) {
            this.$emit("bigFileSize");
          } else {
            this.uploading = true;
            this.uploaded = false;
            this.status = false;
            this.file = uploadFile;
            this.failed = false;
            let formData = new FormData();
            formData.append("file", uploadFile);
            if (this.includeLeId) {
              formData.append("le_id", this.le_id);
            }

            if (!this.tobucket) {
              this.$emit("change", uploadFile);
            } else {
              let res = await axios_instance.post("", formData);
              if (res.data.status) {
                this.uploaded = true;
                this.uploading = false;
                this.showUploadText = true;
                setTimeout(() => {
                  this.showUploadText = false;
                }, 2000);
                this.$emit("change", res);
              }
              this.showCropOption = false;
            }
          }
        }
      } catch (error) {
        this.uploading = false;
        this.failed = true;
        this.status = false;
      }
    },

    getFileType(filename) {
      if (new RegExp(this.imgPattern).test(filename)) {
        return "@/assets/image.svg";
      } else if (new RegExp(this.xlsPattern).test(filename)) {
        return "@/assets/excel.svg";
      } else if (new RegExp(this.pdfPattern).test(filename)) {
        return "@/assets/pdf.svg";
      } else {
        return "";
      }
    },
    // start crop and zoom image script
    editImage(logo) {
      this.uploaded = true;
      this.showCropOption = true;
    },
    cropImage() {
      try {
        this.$refs.cropper.getCroppedCanvas().toBlob(async blob => {
          let formData = new FormData();
          formData.append(
            "file",
            new File([blob], "image." + blob.type.split("/")[1])
          );
          let res = await axios_instance.post("", formData);
          if (res.data.status) {
            this.$emit("editImage", res);
            this.showCropOption = false;
          }
        });
      } catch (error) {
        this.uploading = false;
        this.failed = true;
        this.status = false;
      }
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    close() {
      this.showCropOption = false;
    },

    cancelEvent() {
      this.showPopup = false;
    },
    deleteEvent() {
      this.uploaded = false;
      this.$emit("deleteFile");
      this.showPopup = false;
    },
    // End crop and zoom image script
    del() {
      this.status = true;
      this.showPopup = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
.dragg {
  background-color: red;
  opacity: 0.4;
}
.image-wrapper {
  position: relative;
  width: 300px;
  display: flex;
  height: 140px;
  .legal-entity-logo {
    width: 145px;
    cursor: pointer;
    height: 100px;
    object-fit: contain;
    margin-right: 16px;
  }
  // }
  .delete-img {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 145px;
    height: 100px;
    &:hover {
      display: block;
      background-color: rgba(0, 0, 0, 0.3);
      .edit-icon {
        display: block;
      }
      .delete-icon {
        display: block;
      }
    }
    .edit-icon {
      display: none;
      cursor: pointer;
      position: absolute;
      top: 25%;
      left: 15%;
      padding: 10px;
      border-radius: 50%;
      width: 50px;
      height: 50px;
    }
    .delete-icon {
      display: none;
      cursor: pointer;
      position: absolute;
      top: 25%;
      left: 50%;
      padding: 10px;
      border-radius: 50%;
      width: 50px;
      height: 50px;
    }
  }

  .upload-btn-text {
    color: #6c6c6c;
    font-size: $font-size-small;
    margin-top: 5px;
    cursor: pointer;
    margin-bottom: 8px;
  }
  .upload-button {
    cursor: pointer;
    align-items: center;
    margin-top: 10px;
    label {
      cursor: pointer;
      border: 1px solid #5d409f;
      border-radius: 4px;
      padding: 5px 15px 5px 15px;
      font-size: 15px;
      color: #5d409f;
    }
    span {
      align-self: flex-end;
    }
    .upload-btn {
      height: 28px;
      border-radius: 4px;
      background-color: #5d409f;
      color: #ffffff;
      cursor: pointer;
      font-size: 12px;
      margin-bottom: 8px;
    }
    .upload-photo {
      opacity: 0;
      cursor: pointer;
      position: absolute;
      z-index: -1;
    }
    img {
      height: 27px;
      width: 27px;
      margin-right: 8px;
    }
  }

  .upload-btn-below-text {
    font-size: 10px;
    color: #6e6e6e;
  }
}
.upload-img {
  align-items: center;
  display: flex;
  background-size: 20px 1px, 1px 20px;
  width: 300px;
  height: 100px;
  img {
    margin-right: 16px;
  }
}

.uploading {
  display: flex;
  align-items: center;
  background-size: 20px 1px, 1px 20px;
  width: 300px;
  height: 100px;

  #animated {
    height: 100px;
    width: 10px;
    position: absolute;
    background: #5d409f;
    margin-top: -105px;
    animation: move 2s linear infinite;
    // opacity: 0.75;
  }
  :first-child {
    margin-right: 16px;
    object-fit: cover;
  }
  .imgAlign {
    width: 145px;
    height: 100px;
    background-color: #f5f5f5;
    border-radius: 4px;
    margin-right: 16px;
    img {
      width: 50px;
      height: 30px;
      margin: 33px 0 0 25px;
    }
  }
  .retry-btn {
    font-weight: 500;
    cursor: pointer;
  }
}
.replaceImageBtn {
  position: relative;
  float: left;
}
.uploaded {
  display: flex;
  align-items: center;
  background-size: 20px 1px, 1px 20px;
  width: 300px;
  height: 100px;
  .upload-container {
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
    width: 100%;
    height: 100%;
    display: flex;
    padding: 20px;
    flex-direction: column;
    align-items: center;
  }
}
.upload-failed {
  display: flex;
  align-items: center;
  background-size: 20px 1px, 1px 20px;
  width: 300px;
  height: 100px;
  .imgAlign {
    width: 145px;
    height: 100px;
    background-color: #f5f5f5;
    border-radius: 4px;
    margin-right: 16px;
    img {
      width: 50px;
      height: 30px;
      margin: 33px 0 0 25px;
    }
  }
  .retry-btn {
    height: 28px;
    border-radius: 4px;
    border: solid 1px #34c0be;
    background-color: #ffffff;
    color: #34c0be;
    font-weight: 500;
    cursor: pointer;
    font-size: 12px;
    margin-bottom: 8px;
  }
}
.upload-button {
  //   display: flex;
  align-items: center;
  //   height: 30px;
  margin-top: 50px;
  label {
    cursor: pointer;
    border: 1px solid #5d409f;
    border-radius: 4px;
    padding: 5px 15px 5px 15px;
    font-size: 15px;
    color: #5d409f;
  }
  .upload-btn {
    height: 28px;
    border-radius: 4px;
    background-color: #5d409f;
    color: #ffffff;
    font-size: 12px;
    margin-bottom: 8px;
  }
  .upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
  img {
    height: 27px;
    width: 27px;
    margin-right: 8px;
  }
}

.upload-btn-text {
  color: #6c6c6c;
  font-size: $font-size-small;
  margin-top: 5px;
  margin-bottom: 8px;
}
.uploading-btn-text {
  color: #6c6c6c;
  font-size: $font-size-small;
  margin-top: 2px;
  &.size {
    float: right;
  }
}
.btn-secondary {
  background-color: white;
  color: $color-secondary;
  border-radius: 4px;
  border: 1px solid $color-secondary;
  height: 30px;
  padding: 0px 20px;
  font-size: $font-size-small;
  width: auto;
  margin-top: auto;
  margin-bottom: 10px;
}
.progress-bar {
  width: 200px;
  border: 0.5px solid $color-secondary;
  height: 4px;
  background: white;
  .progress {
    transition: width 5s;
    background: $color-secondary;
    width: 0%;
    height: 4px;
    &.complete {
      width: 100%;
    }
  }
}
.upload-file-text {
  color: #6c6c6c;
  font-size: $font-size-small;
  margin-top: 10px;
  text-decoration: underline;
}

.upload-info {
  margin-top: auto;
  padding-left: 20px;
  padding-top: 15px;
}

.upload-btn-below-text {
  font-size: 10px;
  color: #6e6e6e;
}
.image {
  background: url("../assets/image.svg") no-repeat fixed;
  background-size: 36px 36px;
}

.excel {
  background: url("../assets/excel.svg") no-repeat fixed;
  background-size: 36px 36px;
}

.pdf {
  background: url("../assets/pdf.svg") no-repeat fixed;
  background-size: 36px 36px;
}
.errorimage {
  width: 10%;
}
.cropImage {
  height: 500px;
  width: 700px;
  box-shadow: 3px 3px 11px 0 rgba(0, 0, 0, 0.2);
}
.cropImgActionButtons {
  background: #fff;
  float: left;
  width: 100%;
  padding: 15px;
}
.rightBtns {
  float: right;
}
.setAlignment {
  display: block !important;
}
.replaceImage {
  width: 120px;
  line-height: 76px;
  float: left;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5d409f;
}
.custom-modal .modal-content.modal-sm {
  width: 700px !important;
}
.custom-modal .modal-content .modal-body {
  padding: 0px !important;
}
.custom-modal .modal-content {
  margin: 35px auto 0px auto !important;
}
.uploadText {
  color: rgb(52, 192, 190);
  font-weight: bold;
  margin-top: 5px;
}
.cancelImage {
  width: 169px;
  height: 35px;
  margin-right: 15px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  color: #37c6c0;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  border-radius: 4px;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  border: solid 2px #37c6c0;
  background-color: #ffffff;
}
.setImage {
  width: 169px;
  height: 35px;
  border-radius: 4px;
  background-color: #5d409f;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}
.btnOpt {
  position: relative;
  z-index: 99;
  float: left;
}
.cr-slider-wrap {
  height: 71px;
  line-height: 71px;
  margin: 0 !important;
  text-align: center;
  background: #f9f9f9 !important;
  width: 100% !important;
  float: left;
}
.cr-slider {
  -webkit-appearance: none;
  width: 300px;
  max-width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
  background-color: transparent;
}
.custom-modal .modal-content .modal-header {
  background: #fff;
}
.custom-modal .modal-content .modal-header h3 {
  font-family: Montserrat;
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5d409f;
}
.rotateIconImage {
  font-size: 35px;
  transform: rotate(-90deg);
  color: #555;
}
.rightIcon {
  margin-left: 40px;
}
.rotateIconImage:hover {
  background: #37c6c0;
  color: #fff;
}
</style>
